import * as React from 'react';

const Permissions = React.lazy(() => import('./container'));

export default () => <Permissions />;
